import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReservationSessionActivities from './ReservationSessionActivities';
import { fetchAccessSessionActivities } from 'store/actions/reservations/session/reservationSessionActivities';
import { compose } from 'redux';
import { connect } from 'react-redux';
import translate from 'components/hoc/translate';
import styled from 'styled-components';
import utils from 'helpers/utils';

const StyledWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 1px;
    min-height: 200px;
`;

class ReservationSessionActivitiesContainer extends Component {
    componentDidMount() {
        const {
            fetchSessionActivities,
            record: {
                id,
            },
        } = this.props;

        fetchSessionActivities(id);
    }

    render() {
        const {
            data,
            loading,
            record: {
                id,
            },
            translate,
        } = this.props;

        if (loading) {
            return <StyledWrapper>loading</StyledWrapper>;
        }

        if (utils.isEmpty(data) || utils.isEmpty(data[id])) {
            return (
                <StyledWrapper>
                    <p>{ translate('resources.reservations.show.activities.access_sessions.not_found')}</p>
                </StyledWrapper>
            );
        }

        return (
            <ReservationSessionActivities activities={ data[id] }/>
        );
    }
}

ReservationSessionActivitiesContainer.propTypes = {
    data: PropTypes.object,
    fetchSessionActivities: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    record: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {

    return {
        id: props.record.id,
        data: state.reservationSessionActivities.data,
        loading: state.reservationSessionActivities.loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchSessionActivities: (payload) => {
            dispatch(fetchAccessSessionActivities(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    translate,
);

export default enhance(ReservationSessionActivitiesContainer);


// WEBPACK FOOTER //
// ./src/pages/reservations/show/session/ReservationSessionActivitiesContainer.js